import { getDocs, collection, query, where, getDoc, doc, setDoc } from 'firebase/firestore';
import { COLLECTIONS, partnerApproval } from '@storyworm/schema';

// src/universes.ts
async function listUniverses(db) {
  const snap = await getDocs(collection(db, COLLECTIONS.universes));
  return snap.docs.map((d) => d.data());
}
async function listUniversesByOrg(db, orgId) {
  const snap = await getDocs(
    query(collection(db, COLLECTIONS.universes), where("owner_id", "==", orgId))
  );
  return snap.docs.map((d) => d.data());
}
async function getUniverse(db, universeId) {
  const snap = await getDoc(doc(db, COLLECTIONS.universes, universeId));
  return snap.exists() ? snap.data() : null;
}
async function listOrgs(db) {
  const snap = await getDocs(collection(db, COLLECTIONS.orgs));
  return snap.docs.map((d) => d.data());
}
async function getOrg(db, orgId) {
  const snap = await getDoc(doc(db, COLLECTIONS.orgs, orgId));
  return snap.exists() ? snap.data() : null;
}
async function submitPartnerApproval(db, input) {
  const ref = doc(
    collection(db, COLLECTIONS.universes, input.universe_id, COLLECTIONS.approvals)
  );
  const record = partnerApproval.parse({
    ...input,
    id: input.id ?? ref.id,
    created_at: input.created_at ?? (/* @__PURE__ */ new Date()).toISOString()
  });
  await setDoc(ref, record);
  return record;
}
async function listPartnerApprovals(db, universeId) {
  const snap = await getDocs(
    collection(db, COLLECTIONS.universes, universeId, COLLECTIONS.approvals)
  );
  return snap.docs.map((d) => d.data());
}

export { getOrg, getUniverse, listOrgs, listPartnerApprovals, listUniverses, listUniversesByOrg, submitPartnerApproval };
//# sourceMappingURL=chunk-LV3HULGJ.js.map
//# sourceMappingURL=chunk-LV3HULGJ.js.map